import React from 'react';

import { TopImpactStoryBubble } from '#src/app/pages/homepage/shared/components';

import { useTopImpactStoriesDesktop } from './hooks/useTopImpactStoriesDesktop';

export const TopImpactStoriesDesktop: React.FC = () => {
	const {
		data: { desktopStories },
		actions: { trackStoryClick },
	} = useTopImpactStoriesDesktop();

	return (
		// eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname
		<div className="hidden grid-cols-5 lg:mt-16 lg:grid xl:mt-[120px]" data-testid="top-impact-stories-container">
			{desktopStories.map((story) => (
				<TopImpactStoryBubble key={story.key} story={story} trackStoryClick={trackStoryClick} />
			))}
		</div>
	);
};
